import { MonoTypeOperatorFunction } from 'rxjs';
import { applyErrorHandler } from './apply-error-handler';
import { catchAndRethrow } from './catch-and-rethrow';

export const handleAllErrors = <T>(handler: unknown): MonoTypeOperatorFunction<T> => catchAndRethrow(() => applyErrorHandler(handler));
